export class FontsCollection {
  list = [];
  constructor(list = []) {
    this.list = list;
  }
  get size() {
    return this.list.length;
  }
  toJSON() {
    return {
      list: this.list.map((item) => ({
        ...item,
        fontCollection: item.fontCollection.toJSON()
      }))
    };
  }
}
